import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import React, { useEffect } from 'react';
import { IHeaderViewProps } from './components/header';

const headerView: React.FC<IHeaderViewProps> = props => {
    const { HeaderTag, HeaderContainer, HeaderTopBarContainer, Divider } = props;

    useEffect(() => {
        if (typeof window !== 'undefined' && window.Appcues && props.context?.request?.user?.customerAccountNumber) {
            const { customerAccountNumber } = props.context.request.user;
            const language = props.context.request.sitePath;
            window.Appcues?.identify(customerAccountNumber, { language: language });
        }
    }, [props.context?.request?.user?.customerAccountNumber]);

    return (
        <Module {...HeaderTag}>
            <Node {...HeaderContainer}>
                <Node {...HeaderTopBarContainer}>
                    {props.logo}
                    {_renderReactFragment(props.menuBar)}
                    <Node {...Divider} />
                    {props.preferredStore}
                    {_renderReactFragment(props.siteOptions)}
                    {_renderDesktopAccountBlock(props)}
                    {props.cartIcon}
                </Node>
            </Node>
        </Module>
    );
};

function _renderDesktopAccountBlock(props: IHeaderViewProps): JSX.Element | null {
    const {
        AccountInfoDropdownParentContainer,
        AccountInfoDropdownPopoverConentContainer,
        accountInfoDropdownButton,
        signOutLink,
        signInLink,
        accountLinks
    } = props;

    if (AccountInfoDropdownParentContainer && !props.config.shouldHideShowSignInSignOutLink) {
        if (AccountInfoDropdownPopoverConentContainer) {
            return (
                <Node {...AccountInfoDropdownParentContainer}>
                    {accountInfoDropdownButton}
                    <Node {...AccountInfoDropdownPopoverConentContainer}>
                        {accountLinks ? accountLinks.map(link => link) : false}
                        {signOutLink}
                    </Node>
                </Node>
            );
        } else if (signInLink) {
            return <Node {...AccountInfoDropdownParentContainer}>{signInLink}</Node>;
        }
    }
    props.context.telemetry.error('Header content is empty, module wont render.');
    return null;
}

function _renderReactFragment(items: React.ReactNode[]): JSX.Element | null {
    return (
        <>
            {items && items.length > 0
                ? items.map((slot: React.ReactNode, index: number) => {
                      return <React.Fragment key={index}>{slot}</React.Fragment>;
                  })
                : null}
        </>
    );
}

export default headerView;
